import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { AREE } from "@/data/aree";
export default function Aree() {
  return (
    <div className="container-editorial py-16 lg:py-24" data-testid="page-aree">
      <div className="max-w-3xl">
        <span className="pill">Aree di lavoro</span>
        <h1 className="mt-4 font-display text-5xl sm:text-6xl tracking-tighter leading-[0.95] dark:text-cream">Non lavoro per etichette,<br /><span className="italic font-normal">ma per processi.</span></h1>
        <p className="mt-6 text-lg text-viola/75 dark:text-cream/75">Le persone non arrivano perché «hanno un'identità»: arrivano con storie in cui identità, relazioni, desiderio, stigma e consenso si intrecciano. Per questo organizzo il mio lavoro per ambiti — non per categorie di persone.</p>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-4">
        {AREE.map((a, i) => (
          <Link
            to={`/aree/${a.slug}`}
            key={a.slug}
            className={`${a.color} group rounded-2xl p-8 border border-viola/10 dark:border-cream/10 hover:-translate-y-1 transition-transform duration-300 ${i === AREE.length - 1 && AREE.length % 2 === 1 ? "md:col-span-2" : ""}`}
            data-testid={`aree-item-${a.slug}`}
          >
            <p className="text-[10px] font-semibold uppercase tracking-widest text-viola/60">{a.tag}</p>
            <h2 className="mt-3 font-display text-3xl md:text-4xl leading-tight text-viola break-words hyphens-auto" lang="it">{a.title}</h2>
            <p className="mt-4 text-viola/80 leading-relaxed">{a.intro}</p>
            {a.tags?.length > 0 && (
              <div className="mt-5 flex flex-wrap gap-1.5">
                {a.tags.map((t) => (
                  <span key={t} className="text-[10px] rounded-full bg-white/50 dark:bg-viola/30 px-2 py-1 text-viola/80 font-medium">{t}</span>
                ))}
              </div>
            )}
            <span className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-fucsia group-hover:gap-2 transition-all">
              Approfondisci <ArrowRight size={14} />
            </span>
          </Link>
        ))}
      </div>

      {/* CTA "Quando non sono la persona giusta" */}
      <div className="mt-16 rounded-2xl bg-viola text-cream p-10 md:p-14 grid md:grid-cols-2 items-center gap-10" data-testid="cta-limits">
        <div>
          <span className="inline-flex items-center rounded-full bg-giallo px-3 py-1 text-xs font-semibold uppercase tracking-wider text-viola">Trasparenza</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl leading-tight">Quando potrei non essere la persona giusta.</h2>
          <p className="mt-4 text-cream/80">Non ci sono ambiti che tratto per completezza. Preferisco dire chiaramente cosa non faccio, e orientarti verso colleghə con la specializzazione giusta.</p>
        </div>
        <div className="flex md:justify-end">
          <Link to="/quando-non-sono-la-persona-giusta" className="btn-secondary" data-testid="cta-limits-link">Leggi la nota <ArrowRight size={16} /></Link>
        </div>
      </div>
    </div>
  );
}
